export const truncateText = (str: string, num: number) => {
  return str.slice(0, num) + '...'
}
